module.exports = __webpack_public_path__ + "static/media/018.e92e8a9f.jpg";